import { GetClientsForFilterActionTypes, GetClientsForFilterState, GET_CLIENTS_FOR_FILTER_FAILURE, GET_CLIENTS_FOR_FILTER_REQUEST, GET_CLIENTS_FOR_FILTER_SUCCESS } from './types';

const defaultState: GetClientsForFilterState = {
  isLoading: false,
  errorMessage: ''
};

export default function clientsForFilter(state = defaultState, action: GetClientsForFilterActionTypes): GetClientsForFilterState {
  switch (action.type) {
    case GET_CLIENTS_FOR_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_CLIENTS_FOR_FILTER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ''
      };
    case GET_CLIENTS_FOR_FILTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};